// extracted by mini-css-extract-plugin
export default {"message":"Message_message__A5eSS","error":"Message_error__Fevdf","cross":"Message_cross__TQ18r"};